import apiClient from './api';

// Δεν υπάρχουν ακόμα πραγματικά backend endpoints για αποθήκευση αρχείων — αυτό το service
// ακολουθεί τη σύμβαση ονομασίας/σχήματος του υπόλοιπου app ώστε να είναι έτοιμο για σύνδεση
// μόλις προστεθούν. Μέχρι τότε το FileManagementMenu.vue λειτουργεί με τοπικό (client-side) state.

async function fetchAll(data) {
  try {
    const response = await apiClient.get('/get-documents', data || {}); // Replace with your endpoint
    return response;
  } catch (error) {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      return error.response;
    } else if (error.request) {
      // The request was made but no response was received
      return { success: false, message: "No response received", details: error.request };
    } else {
      // Something happened in setting up the request that triggered an Error
      return { success: false, message: "Request setup error", details: error.message };
    }
  }
}

async function upload(data) {
  try {
    const response = await apiClient.post('/upload-document', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response;
  } catch (error) {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      return { success: false, message: "No response received", details: error.request };
    } else {
      return { success: false, message: "Request setup error", details: error.message };
    }
  }
}

async function updateCategory(data) {
  try {
    const response = await apiClient.post('/update-document-category', data || {}); // Replace with your endpoint
    return response;
  } catch (error) {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      return { success: false, message: "No response received", details: error.request };
    } else {
      return { success: false, message: "Request setup error", details: error.message };
    }
  }
}

async function massArchiveDocuments(data) {
  data.field = 'statusId';
  data.value = 4;
  try {
    const response = await apiClient.post('/mass-update-documents', data); // Replace with your endpoint
    return response;
  } catch (error) {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      return { success: false, message: "No response received", details: error.request };
    } else {
      return { success: false, message: "Request setup error", details: error.message };
    }
  }
}

// Γράφει πραγματικά το αρχείο στο δίσκο, κάτω από public/client-documents/<clientId>/<filename>,
// μέσω του dev-server middleware (βλ. vue.config.js). Λειτουργεί μόνο κατά το 'yarn serve' — σε
// production build δεν υπάρχει το endpoint, οπότε επιστρέφει null και ο caller πρέπει να κάνει
// fallback (π.χ. τοπική αποθήκευση blob σε IndexedDB).
async function uploadToLocalDisk(file, clientId) {
  if (process.env.NODE_ENV !== 'development') return null;

  const params = new URLSearchParams({ clientId: clientId ?? '', filename: file.name });
  try {
    const response = await fetch(`/local-uploads?${params.toString()}`, {
      method: 'POST',
      body: file
    });
    const data = await response.json();
    return data?.success ? data : null;
  } catch (error) {
    return null;
  }
}

export { fetchAll, upload, updateCategory, massArchiveDocuments, uploadToLocalDisk };
